import { Edit, ListButton, TopToolbar } from 'react-admin';
import ChevronLeft from '@material-ui/icons/ChevronLeft';

import BankForm from './BankForm';

const BankActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const BankEdit = (props: any) => {
  return (
    <Edit actions={<BankActions {...props} />} {...props}>
      <BankForm />
    </Edit>
  );
};

export default BankEdit;
